import { FC, useCallback, useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";

import { QueryLink } from "@/parts";

import { Modal, Button } from "react-materialize";

import "./style.sass";

import { ReactComponent as BackShadow } from "./back_shadow.svg";

import { humanImg } from "@/assets/Splashscreen people";

import { useMediaQuery } from "react-responsive";

import { actions, useTrackedStore, store } from "@assets/store";

import {
	checkStorageAndStore,
	formatPercent,
	itemIsStored,
} from "@assets/utils";

import { pdcStore } from "@assets/store/pdcStore";
import { ticket_promotion_mechanics } from "@assets/constants/ticket_promotion_mechanics";
import { MechanicContent } from "./MechanicContent";

export const SplashScreenPopup: FC = () => {
	const { pathname, search } = useLocation();

	const trackingIds = useMemo(
		() => new URLSearchParams(search).get("trackingIds"),
		[search],
	);

	const showSplashScreenPopup = pdcStore.use.showSplashScreenPopup();

	const bannerPromotions = pdcStore.use.bannerPromotions();

	const customer = useTrackedStore().app.customer();

	const showOfferConditions =
		useTrackedStore().app.OfferConditionsModalOpened();

	const item = useMemo(() => {
		if (customer.customerId && bannerPromotions) {
			return bannerPromotions.find(
				(item) =>
					item?.mechanic &&
					item?.id &&
					ticket_promotion_mechanics.includes(item?.mechanic) &&
					(item.requiresRegisterComplete
						? customer.isRegisterComplete
						: true) &&
					!itemIsStored(localStorage, "wasInSplashScreenPopup", item?.id),
			);
		}
	}, [customer, bannerPromotions]);

	useEffect(() => {
		if (
			item &&
			item?.id &&
			!pathname.includes("/cadastro") &&
			!pathname.includes("webpush-pagina") &&
			!checkStorageAndStore(sessionStorage, "showedSplashScreen", "true")
		) {
			pdcStore.set.showSplashScreenPopup(true);
			pdcStore.set.increment_showed_popups_count();
		}
	}, [item, trackingIds, pathname]);

	const mainButton = useMemo(
		() =>
			bannerPromotions ? (
				<QueryLink to="/" className="main_button_container">
					<Button
						flat
						modal="close"
						node="button"
						className="white common_text_button common_button_shadow main_button primary_color_text"
					>
						{bannerPromotions.filter((i) => !i.activated).length
							? "Desbloquear minhas ofertas"
							: "Ver minhas ofertas"}
					</Button>
				</QueryLink>
			) : (
				<></>
			),
		[bannerPromotions],
	);

	const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

	const buttons = useMemo(
		() => (
			<>
				{mainButton}

				<Button
					flat
					waves="light"
					className="conditions_button text_primary_background"
					onClick={() => {
						actions.app.OfferConditionsModalItem(item);
						actions.app.OfferConditionsModalOpened(true);
					}}
				>
					Confira as condições da oferta
				</Button>
			</>
		),
		[item, mainButton],
	);

	const renderHumanImage = useMemo(
		() => (
			<img
				src={humanImg()}
				alt="human"
				className={isMobile ? "mobile_human" : "desktop_human"}
			/>
		),
		[isMobile],
	);

	return (
		<Modal
			id="splash_screen_popup"
			open={showSplashScreenPopup}
			options={{
				dismissible: true,
				opacity: 0.5,
				onCloseEnd: () => pdcStore.set.showSplashScreenPopup(false),
			}}
			//@ts-ignore
			className={`${"ticket"}`}
			onClick={() => {
				if (showOfferConditions) {
					actions.app.OfferConditionsModalOpened(false);
				}
			}}
		>
			<Button
				flat
				className="close-button text_primary_background"
				onClick={() => pdcStore.set.showSplashScreenPopup(false)}
			>
				<i className="material-icons">close</i>
			</Button>

			<BackShadow className="human_background" />

			{!isMobile && renderHumanImage}

			<div className="popup_content text_primary_background">
				<MechanicContent item={item} HumanImage={renderHumanImage} />

				<div className="bottom_content">
					<div className="header">
						Aproveite a oferta imperdível que separamos para você!
					</div>

					{isMobile ? buttons : <div className="buttons">{buttons}</div>}
				</div>
			</div>

			<div className="footer">
				<img
					src={window.parameters.glob_programLogo}
					alt={window.parameters.glob_programName}
					className="logo"
				/>
			</div>
		</Modal>
	);
};
